import React, { useState } from 'react';
import { dictionaryTerms } from '../../data/dictionaryData';

export const Dictionary: React.FC = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedCategory, setSelectedCategory] = useState<string>('all');
    const [expandedId, setExpandedId] = useState<string | null>(null);

    const categories = ['all', '공조', '냉동', '에어컨', '전기', '배관', '일반'];

    const filtered = dictionaryTerms.filter((term) => {
        const matchesSearch =
            term.term.toLowerCase().includes(searchQuery.toLowerCase()) ||
            term.description.includes(searchQuery);
        const matchesCategory = selectedCategory === 'all' || term.category === selectedCategory;
        return matchesSearch && matchesCategory;
    });

    const categoryColors: Record<string, string> = {
        '공조': '#e3f2fd',
        '냉동': '#e8f5e9',
        '에어컨': '#f3e5f5',
        '전기': '#fff8e1',
        '배관': '#ffedd5',
        '일반': '#f5f5f5',
    };

    const categoryTextColors: Record<string, string> = {
        '공조': '#1e3a5f',
        '냉동': '#5a7a6a',
        '에어컨': '#5a5a5a',
        '전기': '#8b6914',
        '배관': '#8b4513',
        '일반': '#5a5a5a',
    };

    return (
        <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div style={{ position: 'relative' }}>
                <span style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', fontSize: '16px', color: '#a09890' }}>🔍</span>
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="용어 검색..."
                    style={{
                        width: '100%',
                        padding: '12px 12px 12px 36px',
                        border: '1px solid #c4b8a5',
                        borderRadius: '10px',
                        fontSize: '14px',
                        outline: 'none',
                        fontFamily: "'Noto Sans KR', sans-serif",
                        backgroundColor: 'white'
                    }}
                />
            </div>

            <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' }}>
                {categories.map((cat) => (
                    <button
                        key={cat}
                        onClick={() => setSelectedCategory(cat)}
                        style={{
                            padding: '6px 12px',
                            borderRadius: '10px',
                            border: '1px solid #c4b8a5',
                            fontSize: '12px',
                            whiteSpace: 'nowrap',
                            cursor: 'pointer',
                            backgroundColor: selectedCategory === cat ? '#1e3a5f' : 'white',
                            color: selectedCategory === cat ? 'white' : '#5a5a5a',
                            fontWeight: selectedCategory === cat ? 700 : 400
                        }}
                    >
                        {cat === 'all' ? '전체' : cat}
                    </button>
                ))}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {filtered.map((term) => {
                    const isExpanded = expandedId === term.id;

                    return (
                        <div
                            key={term.id}
                            onClick={() => setExpandedId(isExpanded ? null : term.id)}
                            style={{
                                backgroundColor: 'white',
                                border: '1px solid #c4b8a5',
                                padding: '14px 16px',
                                cursor: 'pointer',
                                transition: 'all 0.15s'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#faf8f5';
                                e.currentTarget.style.borderColor = '#1e3a5f';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'white';
                                e.currentTarget.style.borderColor = '#c4b8a5';
                            }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <div style={{ flex: 1 }}>
                                    <h3 style={{ fontWeight: 700, fontSize: '15px', color: '#2c2c2c' }}>{term.term}</h3>
                                    <span style={{
                                        display: 'inline-block',
                                        marginTop: '4px',
                                        padding: '2px 8px',
                                        borderRadius: '10px',
                                        fontSize: '11px',
                                        fontWeight: 700,
                                        backgroundColor: categoryColors[term.category] || '#f5f5f5',
                                        color: categoryTextColors[term.category] || '#5a5a5a'
                                    }}>
                                        {term.category}
                                    </span>
                                </div>
                                <span style={{ fontSize: '14px', color: '#a09890' }}>
                                    {isExpanded ? '▾' : '▸'}
                                </span>
                            </div>

                            {isExpanded && (
                                <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px dashed #c4b8a5' }}>
                                    <p style={{ fontSize: '14px', color: '#4b5563', lineHeight: 1.6 }}>
                                        {term.description}
                                    </p>
                                    {term.relatedTerms && (
                                        <div style={{ marginTop: '12px' }}>
                                            <p style={{ fontSize: '11px', color: '#a09890', marginBottom: '4px' }}>관련 용어</p>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                {term.relatedTerms.map((related) => (
                                                    <span key={related} style={{
                                                        fontSize: '11px',
                                                        padding: '3px 8px',
                                                        backgroundColor: '#f4f1ea',
                                                        border: '1px solid #c4b8a5',
                                                        borderRadius: '10px',
                                                        color: '#4b5563'
                                                    }}>
                                                        {related}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>

            {filtered.length === 0 && (
                <div style={{ textAlign: 'center', padding: '48px 0', color: '#a09890' }}>
                    <p>검색 결과가 없습니다</p>
                </div>
            )}
        </div>
    );
};